import { Component, OnInit, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-highlight-cards',
    templateUrl: './highlight-cards.component.html',
    styleUrls: ['./highlight-cards.component.scss'],
    imports: [TranslateModule, RouterLink]
})
export class HighlightCardsComponent implements OnInit {

    @Input() highlights: string = '[]';
    @Input() chassisnr: string;
    highlightsArray;

    ngOnInit(): void {
        this.highlightsArray = JSON.parse(this.highlights);
        this.highlightsArray.forEach(highlight => {
            if (!highlight.HEADERIMAGE.startsWith('/img/')) {
                highlight.HEADERIMAGE = '/img/landtechnik/produkte/phkey/technik/' + highlight.HEADERIMAGE;
            }
        });
    }

    findFirstImage() {
        if (this.highlightsArray) {
            const regex = /<img[^>]+src="([^">]+)/g;
            for (const entry of this.highlightsArray) {
                const firstImage = regex.exec(entry.TEXT1);
                const srcStart = firstImage[0].search('"') + 1;
                entry.coverImage = firstImage[0].substring(srcStart);
            }
        }
    }

}
